document.addEventListener("DOMContentLoaded", function () {
  const thumbsSwiper = new Swiper(".product-thumbs-swiper", {
    direction: "horizontal",
    slidesPerView: 5,
    spaceBetween: 10,
    speed: 600,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      0: {
        slidesPerView: 5.2,
        spaceBetween: 6,
      },
      980: {
        spaceBetween: 10,
      },
    },
  });

  // Main product media swiper
  const mainSwiper = new Swiper(".product-media-swiper", {
    spaceBetween: 10,
    loop: true,
    speed: 600,
    navigation: {
      nextEl: ".product_main_next",
      prevEl: ".product_main_prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: ".product-media-swiper .main-swiper_pagination",
      clickable: true,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });
});